export default "__VITE_ASSET__b455ff3b__"